import React from 'react';

/**
 * 공용 토글 스위치 — 라벨/설명 + 스위치 한 줄.
 * AutoStartToggle과 LogoutNotificationToggle에 복붙돼 있던 동일 마크업을
 * 세 번째 사용처(알림 설정 패널)가 생기는 시점에 추출했다. 순수 표현 컴포넌트 —
 * 상태·로딩·저장은 호출부가 소유한다.
 */
interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  label,
  description,
  disabled = false,
}) => (
  <div className="flex items-center justify-between py-3">
    <div>
      <p className="text-sm text-slate-800">{label}</p>
      {description && <p className="text-xs text-slate-500">{description}</p>}
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={() => onChange(!checked)}
      disabled={disabled}
      className={`relative shrink-0 w-11 h-6 rounded-full transition-colors ${checked ? 'bg-brand-600' : 'bg-slate-300'} ${disabled ? 'opacity-50' : ''}`}
    >
      <div
        className={`absolute top-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform ${checked ? 'translate-x-[22px]' : 'translate-x-0.5'}`}
      />
    </button>
  </div>
);
